export const SET_FORM = 'SET_FORM';

export default {
  SET_FORM
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/types.js